(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.smjReady === '1') return;
    root.dataset.smjReady = '1';

    var dataEl = root.querySelector('[data-smj-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = data.variants || [];
    var idInput = root.querySelector('[data-smj-variant-id]');
    var qtyInput = root.querySelector('[data-smj-qty-input]');
    var qtyOut = root.querySelector('[data-smj-qty-out]');
    var track = root.querySelector('[data-smj-track]');
    var dots = root.querySelector('[data-smj-dots]');
    var atc = root.querySelector('[data-smj-atc]');
    var optLabel = root.querySelector('[data-smj-opt-label]');
    var priceNow = root.querySelector('[data-smj-price-now]');
    var priceWas = root.querySelector('[data-smj-price-was]');
    var stickyName = root.querySelector('[data-smj-sticky-name]');
    var stickyThumb = root.querySelector('[data-smj-sticky-thumb]');
    var sticky = root.querySelector('[data-smj-sticky]');
    var buy = root.querySelector('[data-smj-buy]');

    var current = 0;
    variants.forEach(function (v, i) { if (String(v.id) === String(data.selectedId)) current = i; });

    function money(cents) {
      var s = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + s;
    }

    function renderGallery(v) {
      if (!track) return;
      track.innerHTML = v.images.map(function (im) {
        return '<figure class="smj-gal__fig"><img src="' + im.src + '" alt="' + im.alt.replace(/"/g, '&quot;') + '" loading="lazy" width="1500" height="1500"><figcaption class="smj-gal__cap">' + im.cap + '</figcaption></figure>';
      }).join('');
      if (dots) {
        dots.innerHTML = v.images.map(function (im, i) {
          return '<button type="button" aria-label="Show image ' + (i + 1) + ' of ' + v.images.length + '" aria-current="' + (i === 0 ? 'true' : 'false') + '" data-smj-dot="' + i + '"></button>';
        }).join('');
      }
      track.scrollLeft = 0;
    }

    function select(i, pushUrl) {
      var v = variants[i];
      if (!v) return;
      current = i;
      if (idInput) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      root.querySelectorAll('[data-smj-opt]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(Number(b.dataset.smjOpt) === i));
      });
      if (optLabel) optLabel.textContent = 'Cover \u2014 ' + v.name;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        if (v.compareAt && v.compareAt > v.price) {
          priceWas.textContent = money(v.compareAt);
          priceWas.hidden = false;
        } else { priceWas.hidden = true; }
      }
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? data.addLabel : data.soldOutLabel;
      }
      if (stickyName) stickyName.textContent = v.name + ' \u00b7 ' + money(v.price);
      if (stickyThumb) stickyThumb.style.backgroundImage = 'url("' + v.images[0].src + '")';
      renderGallery(v);
      if (pushUrl && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-smj-opt]');
      if (opt) { e.preventDefault(); select(Number(opt.dataset.smjOpt), true); return; }

      var dot = e.target.closest('[data-smj-dot]');
      if (dot && track) {
        e.preventDefault();
        track.scrollTo({ left: track.clientWidth * Number(dot.dataset.smjDot), behavior: 'smooth' });
        return;
      }

      var step = e.target.closest('[data-smj-step]');
      if (step && qtyInput) {
        e.preventDefault();
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(step.dataset.smjStep));
        qtyInput.value = next;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (qtyOut) qtyOut.textContent = next;
        return;
      }

      var q = e.target.closest('[data-smj-faq]');
      if (q) {
        e.preventDefault();
        var item = q.parentElement;
        var open = item.dataset.open === 'true';
        item.dataset.open = open ? 'false' : 'true';
        q.setAttribute('aria-expanded', String(!open));
        var sign = q.querySelector('i');
        if (sign) sign.textContent = open ? '+' : '\u2212';
      }
    });

    if (track && dots) {
      track.addEventListener('scroll', function () {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        dots.querySelectorAll('button').forEach(function (b, n) {
          b.setAttribute('aria-current', String(n === i));
        });
      }, { passive: true });
    }

    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          sticky.dataset.on = String(!en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(buy);
    }

    var stickyBtn = root.querySelector('[data-smj-sticky-add]');
    if (stickyBtn && atc) {
      stickyBtn.addEventListener('click', function (e) { e.preventDefault(); atc.click(); });
    }

    select(current, false);
  }

  function boot() {
    document.querySelectorAll('[data-smj-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', boot);
})();
